import { useState, useEffect } from 'react';
import { useOperator } from '@/lib/operator-context';
import { getFlow } from '@/lib/operator-api/flows-client';
import type { FlowNode } from '@/lib/operator-api/flows-client';

export function useFlowData(options: { businessType: string; locale: string; flowSlug?: string }) {
  const { locale, flowSlug = 'booking' } = options;
  const lang = locale === 'pt-BR' ? 'pt-BR' : 'en';
  const { selectedBusinessId } = useOperator();
  const [nodes, setNodes] = useState<FlowNode[]>([]);

  useEffect(() => {
    if (!selectedBusinessId) return;
    let cancelled = false;

    getFlow(flowSlug, selectedBusinessId).then((flow) => {
      if (!cancelled) setNodes(flow.nodes);
    }).catch(() => {
      // keep empty nodes on error
    });

    return () => { cancelled = true; };
  }, [selectedBusinessId, flowSlug]);

  return {
    nodes,
    getNodeById: (id: string): { data: { title: string; messageText?: string | null; templateSlug?: string | null } } | null => {
      const node = nodes.find((n) => n.slug === id);
      if (!node) return null;
      const title = lang === 'pt-BR'
        ? (node.namePtBr || node.name)
        : node.name;
      const messageText = lang === 'pt-BR'
        ? (node.messageTextPtBr || node.messageText)
        : node.messageText;
      return { data: { title, messageText, templateSlug: node.templateSlug } };
    },
  };
}
